// Arquivo gerado por scripts/gerar-versao.js. Não editar.
export const versao = {
  "versao": "1.0.4",
  "commit": "8f9993c5",
  "dataBuild": "2026-11-05T12:27:34.764Z"
};
